/* LP genérica Tempo Lar: seleção de kit (troca preço e foto), galeria, carrossel e barra fixa. */
(function () {
  'use strict';
  var root = document.getElementById('tl-lp');
  var dataEl = document.getElementById('tl-data');
  if (!root || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var V = data.variants;
  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function money(c) { return fmt.format(c / 100); }
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  var form = $('#tl-form'), vidInput = $('#tl-vid'), qtyInput = $('#tl-qty'), mainImg = $('#tl-main');
  var state = { kit: data.defaultKit };
  function current() { return V.filter(function (v) { return v.kit === state.kit; })[0] || V[0]; }
  function setText(id, t) { var el = document.getElementById(id); if (el) el.textContent = t; }
  function showMedia(src, alt, mediaId) {
    if (!mainImg || !src) return;
    mainImg.setAttribute('src', src);
    mainImg.setAttribute('alt', alt || '');
    $$('.tl-thumb').forEach(function (o) {
      o.classList.toggle('is-on', !!mediaId && String(o.getAttribute('data-media')) === String(mediaId));
    });
  }
  function render(swap) {
    var cur = current(), cents = cur.price;
    $$('.tl-kit').forEach(function (b) {
      var on = b.getAttribute('data-kit') === cur.kit;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    vidInput.value = cur.id;
    setText('tl-price', money(cents));
    var inst = Math.round(cents * (1 + data.rate / 100) / data.inst);
    setText('tl-inst', 'ou ' + data.inst + 'x de ' + money(inst) + (data.rate === 0 ? ' sem juros' : ''));
    var pixEl = document.getElementById('tl-pix');
    if (pixEl) {
      if (data.pix > 0) { pixEl.hidden = false; pixEl.textContent = money(Math.round(cents * (1 - data.pix / 100))) + ' no Pix (' + data.pix + '% de desconto)'; }
      else { pixEl.hidden = true; }
    }
    setText('tl-selected', '✓ Selecionado: ' + cur.kit);
    setText('tl-bar-price', money(cents));
    setText('tl-bar-sel', cur.kit);
    if (swap && cur.img) showMedia(cur.img, cur.alt, cur.media);
  }
  $$('.tl-kit').forEach(function (b) {
    b.addEventListener('click', function () { state.kit = b.getAttribute('data-kit'); render(true); });
  });
  $$('.tl-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-media'));
    });
  });
  function clampQty() {
    var n = parseInt(qtyInput.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 20) n = 20;
    qtyInput.value = n;
  }
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
      clampQty();
    });
  });
  qtyInput.addEventListener('change', clampQty);
  form.addEventListener('submit', clampQty);
  $$('[data-tl-cta]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.getElementById('tl-buy');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  var bar = $('#tl-bar'), buyRow = $('#tl-buyrow'), barBtn = $('#tl-bar-btn');
  if (barBtn) barBtn.addEventListener('click', function () { clampQty(); form.submit(); });
  if (bar && buyRow && 'IntersectionObserver' in window) {
    var buyVisible = true, footVisible = false;
    var sync = function () { bar.classList.toggle('is-on', !buyVisible && !footVisible); };
    new IntersectionObserver(function (es) { buyVisible = es[0].isIntersecting; sync(); }).observe(buyRow);
    var foot = document.querySelector('footer, .footer');
    if (foot) new IntersectionObserver(function (es) { footVisible = es[0].isIntersecting; sync(); }).observe(foot);
  } else if (bar) { bar.classList.add('is-on'); }
  var track = $('#tl-clips'), dots = $$('#tl-dots span');
  if (track && dots.length) {
    track.addEventListener('scroll', function () {
      var first = track.firstElementChild;
      if (!first) return;
      var step = first.getBoundingClientRect().width + 12;
      var idx = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / step)));
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }, { passive: true });
  }
  var vs = $$('#tl-clips video');
  if (vs.length) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { vs.forEach(function (v) { v.controls = true; }); }
    else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.35 });
      vs.forEach(function (v) { io.observe(v); });
    }
  }
  render(false);
})();